<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="$emit('close')">
    <div class="bg-white rounded-lg p-6 max-w-md w-full">
      <div class="flex justify-between items-start mb-4">
        <h2 class="text-xl font-bold">Quick Call</h2>
        <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
          <XMarkIcon class="w-6 h-6" />
        </button>
      </div>
      
      <div class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">Select Profile</label>
          <select v-model="selectedProfile" class="input w-full">
            <option value="">Choose a profile...</option>
            <option v-for="profile in profiles" :key="profile.id" :value="profile.id">
              {{ profile.name }}
            </option>
          </select>
        </div>
        
        <div class="flex justify-end space-x-2">
          <button @click="$emit('close')" class="btn btn-secondary">Cancel</button>
          <button @click="initiateCall" :disabled="!selectedProfile" class="btn btn-primary">
            Start Call
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { useProfileStore } from '@/stores/profiles'

defineProps({
  profile: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['close', 'call'])
const profileStore = useProfileStore()

const selectedProfile = ref('')

// Use real profiles from store
const profiles = computed(() => profileStore.profiles)

async function initiateCall() {
  if (!selectedProfile.value) return
  emit('call', selectedProfile.value)
}

onMounted(async () => {
  // Load profiles if not already loaded
  if (!profiles.value?.length) {
    try {
      await profileStore.fetchProfiles()
    } catch (error) {
      console.error('Failed to load profiles:', error)
    }
  }
})
</script>